import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ChangableComponent } from '@app/models/changable.component';
import { PlatformService } from '@core/services';
import { WebsocketService } from '@core/websocket';
import { ErrorNotificationService } from '@shared/error-notification/error-notification.service';
import { Collection, Meeting, UserService } from 'lingo2-models';
import { DeviceDetectorService } from 'ngx-device-detector';
import { takeUntil } from 'rxjs';
import {
  PaymentCheckoutWizardCheckoutStepType,
  PaymentCheckoutWizardService,
} from '../payment-checkout-wizard.service';

@Component({
  selector: 'app-checkout-steps',
  templateUrl: './checkout-steps.component.html',
  styleUrls: ['./checkout-steps.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckoutStepsComponent extends ChangableComponent implements OnInit {
  @Input() public set steps(steps: PaymentCheckoutWizardCheckoutStepType[]) {
    this.stepList = steps;
  }

  @Input() public set content(value: Meeting | UserService | Collection) {
    if (!value) {
      this._content = new UserService();
      return;
    }
    this._content = value;
  }

  public stepList: PaymentCheckoutWizardCheckoutStepType[];
  public _content: Meeting | UserService | Collection = null;

  public constructor(
    public errorNotificationService: ErrorNotificationService,
    public deviceService: DeviceDetectorService,
    protected websocketService: WebsocketService,
    public models: PaymentCheckoutWizardService,
    protected readonly cdr: ChangeDetectorRef,
    protected readonly platform: PlatformService,
  ) {
    super(cdr, platform);
  }

  public stepTitle(step: PaymentCheckoutWizardCheckoutStepType): string {
    return (
      {
        teacher: 'payment-checkout-wizard.steps.' + this.models.contentType(this._content) + '.teacher',
        detail: 'payment-checkout-wizard.steps.' + this.models.contentType(this._content) + '.detail',
        datetime: 'payment-checkout-wizard.steps.' + this.models.contentType(this._content) + '.date-and-time',
        payment: 'payment-checkout-wizard.steps.' + this.models.contentType(this._content) + '.payment',
      }[step] || step
    );
  }

  public isPassedStep(step: PaymentCheckoutWizardCheckoutStepType): boolean {
    return this.models.passed_steps[step] || false;
  }

  public isCurrentStep(step: PaymentCheckoutWizardCheckoutStepType): boolean {
    return this.models.step === step;
  }

  public ngOnInit() {
    this.models.state$.pipe(takeUntil(this.destroyed$)).subscribe({
      next: (step) => {
        this.detectChanges();
      },
      error: (error) => {
        this.errorNotificationService.captureError(error, 'LOAD-SOMEDATA');
        this.detectChanges();
      },
    });
  }

  public trackByFn(index) {
    return index;
  }
}
